import { render, staticRenderFns } from "./addSupervisionTrain.vue?vue&type=template&id=2a6c7fb6&scoped=true&"
import script from "./addSupervisionTrain.vue?vue&type=script&lang=js&"
export * from "./addSupervisionTrain.vue?vue&type=script&lang=js&"
import style0 from "./addSupervisionTrain.vue?vue&type=style&index=0&id=2a6c7fb6&lang=stylus&scoped=true&"
import style1 from "./addSupervisionTrain.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./addSupervisionTrain.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c7fb6",
  null
  
)

export default component.exports